/* Preserve the selected option when arriving from catalog quick view. */
(() => {
  if(window.MuroojProduct){window.MuroojProduct.init();return;}
  const instances=new Map();
  function init(){document.querySelectorAll('[data-product-page]').forEach(root=>{
    if(instances.has(root))return;
    const controller=new AbortController();instances.set(root,controller);
    const select=root.querySelector('[data-variant]');
    if(!select)return;
    const requested=new URLSearchParams(location.search).get('variant');
    if(requested&&[...select.options].some(option=>option.value===requested)){
      select.value=requested;select.dispatchEvent(new Event('change',{bubbles:true}));
    }
    select.addEventListener('change',()=>{
      const url=new URL(location.href);url.searchParams.set('variant',select.value);
      history.replaceState(null,'',url.pathname+url.search+url.hash);
    },{signal:controller.signal});
  });}
  window.MuroojProduct={init};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('shopify:section:unload',event=>instances.forEach((controller,root)=>{if(event.target.contains(root)){controller.abort();instances.delete(root);}}));
})();
